import { Box, Typography } from '@mui/material'
import { ReviewTaskComponent, RevokeTaskComponent, GrantTaskComponent, ActionTaskComponent } from 'components/core/task/task-type/index'
import { GrantTaskType, RevokeTaskType, CertifyTaskType, ActionTaskType } from 'components/pages/task/type'
import { TaskType } from 'pbts/c1/api/task/v1/task'

import React from 'react'
import { FormattedMessage } from 'react-intl'

export const TaskTypeComponent: React.FC<{ taskType: TaskType | undefined }> = ({ taskType }) => {
    const unknown = (
        <Box>
            <Typography>
                <FormattedMessage id="Components_Tasks_Type_Unknown" defaultMessage="Unknown" />
            </Typography>
        </Box>
    )
    if (!taskType) {
        return unknown
    }
    switch (taskType.taskType.oneofKind) {
        case GrantTaskType.taskType.oneofKind:
            return <GrantTaskComponent />
        case RevokeTaskType.taskType.oneofKind:
            return <RevokeTaskComponent />
        case CertifyTaskType.taskType.oneofKind:
            return <ReviewTaskComponent />
        case ActionTaskType.taskType.oneofKind:
            return <ActionTaskComponent />
        default:
            return unknown
    }
}
